import { render, staticRenderFns } from "./training-resources-banner-widget.vue?vue&type=template&id=2f2d2a81"
import script from "./training-resources-banner-widget.vue?vue&type=script&lang=ts"
export * from "./training-resources-banner-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports